import { CardElement, useElements } from '@stripe/react-stripe-js'
import type {
	StripeCardElement,
	StripeCardElementChangeEvent,
} from '@stripe/stripe-js'

interface StripeCardInputProps {
	onChange: (card: StripeCardElement) => void
	onError: (err?: string) => void
}

const style = {
	base: {
		color: '#494949',
		fontWeight: 300,
		fontSize: '14px',
		fontFamily: 'Nunito, sans-serif',
		fontSmoothing: 'antialiased',

		'::placeholder': {
			color: '#6c757d',
		},
		':-webkit-autofill': {
			color: '#6c757d',
		},
	},
	invalid: {
		color: '#E25950',

		'::placeholder': {
			color: '#6c757d',
		},
	},
}

export const StripeCardInput = ({
	onChange,
	onError,
}: StripeCardInputProps) => {
	const elements = useElements()

	const handleChange = ({
		empty,
		complete,
		error,
	}: StripeCardElementChangeEvent) => {
		const element = elements?.getElement(CardElement)

		if (!element) return

		console.log({ complete, empty, error })

		onChange(element)

		if (error?.message || !complete) {
			onError(error?.message || 'errors:forms.cardIncomplete')
		} else {
			onError(undefined)
		}
	}

	return (
		<CardElement
			options={{ style }}
			className='h-[40px] rounded-lg border px-4 pt-[11px]'
			onChange={handleChange}
		/>
	)
}
